import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-jquery',
	templateUrl:'./JQueryPluginPage.html',
	styles: [],
	styleUrls:['./JQueryPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQueryPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_604 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>jquery</artifactId>
</dependency>
\`\`\``;
	mdContent_605 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:jquery:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_606 = `\`\`\`json
"jquery": "^4.0.0"
"@types/jquery": "*"
"jquery-migrate": "^4.0.2"
\`\`\``;
	mdContent_607 = `\`\`\`java
// module-info.java
module com.myapp {
    requires com.jwebmp.plugins.jquery;
}

// jQuery ($) is now available in the browser
\`\`\``;
	mdContent_608 = `\`\`\`java
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>jquery</artifactId>
</dependency>
\`\`\``;
	mdContent_609 = `\`\`\`java
// module-info.java
module com.myapp {
    requires com.jwebmp.plugins.jquery;
}

// jQuery is automatically available as a global script.
// $ and jQuery are accessible in the browser.
// No additional Java configuration needed.
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
